import Component from '../inherited/Component'

export default class AnimationsScrollingBlocks extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._spaceHolder = this._elem.querySelector('.space-holder')
    this._horizontal = this._elem.querySelector('.horizontal')
    this._sticky = this._elem.querySelector('.sticky')
    this._images = this._elem.querySelectorAll('.scrolling-blocks-image')
  }

  mount () {
    this._setHeight()

    window.addEventListener('scroll', () => {
      this._horizontalScroll()
      this._parallaxImages()
    })

    window.addEventListener('resize', () => {
      this._setHeight()
    })
  }

  _setHeight () {
    function calcDynamicHeight(ref) {
      const vw = window.innerWidth
      const vh = window.innerHeight
      const objectWidth = ref.scrollWidth
      return objectWidth - vw + vh
    }

    this._spaceHolder.style.height = `${calcDynamicHeight(this._horizontal)}px`
  }

  _horizontalScroll () {
    this._horizontal.style.transform = `translateX(-${this._sticky.offsetTop}px)`
  }

  _parallaxImages () {
    let sectionHeight = this._spaceHolder.offsetHeight - this._horizontal.offsetHeight
    let imageMove = 30 - (this._sticky.offsetTop/sectionHeight * 30)

    for (let image of this._images) {
      image.style.left = `-${imageMove}%`
    }
  }
}